module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/mirai_senryaku_kyoshou-5cbd92e1915a69df6fe00356c15945be.png";